export default __webpack_public_path__ + "static/media/warning--curve-right--g1.e03eb082.png";